/* ••[1]••••••••••••••••••••••••• EventCarouselModel.ts •••••••••••••••••••••••••••••• */

import ProviderFactory from "../core/ProviderFactory";
import OcontentMiscProvider from "../core/providers/ocontent/OcontentMiscProvider";
import {
  OcontentProviderType,
  ProviderConfiguration,
} from "../core/types/Provider";
import { EventCarouselItem } from "../core/types/EventCarousel";

export default abstract class EventCarouselModel {
  private static eventCarouselCache: Array<EventCarouselItem>;
  private static miscProvider: OcontentMiscProvider = ProviderFactory.create(
    OcontentProviderType.Misc,
    ProviderConfiguration.ocontent
  );

  public static async getEventCarouselData(): Promise<Array<EventCarouselItem> | null> {
    if (!EventCarouselModel.eventCarouselCache) {
      EventCarouselModel.eventCarouselCache =
        await EventCarouselModel._getEventCarouselData();
    }

    return EventCarouselModel.eventCarouselCache;
  }

  private static async _getEventCarouselData(): Promise<Array<EventCarouselItem> | null> {
    try {
      const items = await EventCarouselModel.miscProvider.getEventCarousel();
      return items;
    } catch (err) {
      console.error(err);

      return null;
    }
  }
}
